import { render, staticRenderFns } from "./SimpleView.vue?vue&type=template&id=d8210a2a&scoped=true&"
import script from "./SimpleView.vue?vue&type=script&lang=js&"
export * from "./SimpleView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleView.vue?vue&type=style&index=0&id=d8210a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8210a2a",
  null
  
)

export default component.exports